class Watermark {
  // eslint-disable-next-line no-useless-constructor
  constructor(options) {
    this.init(options)
    // 图片base64
    this.imageUrl = this.createImg()
    // 水印dom
    this.waterDom = this.createDom()
    // 全局添加
    document.body.appendChild(this.waterDom)
    // 监听改动
    this.watcherDelWaterDom()
    this.watch()
  }

  init(options) {
    this.text = options.text || 'water mark'
    this.style = options.style || ''
    // 旋转角度
    this.rotate = options.rotate || -20
    // 字体大小
    this.fontSize = options.fontSize || 16
  }

  // 生成水印图片
  createImg() {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    canvas.style.marginLeft = '300px'
    canvas.style.background = '#ccc'
    const textWidth = this.computerWidth({
      text: this.text,
      fontSize: `${this.fontSize}px`
    })
    this.computerSide(textWidth)
    const padding = this.fontSize + 40
    // 计算宽度
    canvas.width = this.width + padding
    canvas.height = this.height + padding + 180
    ctx.beginPath()
    ctx.translate(canvas.width / 2, canvas.height / 2)
    ctx.rotate((-20 * Math.PI) / 180)
    ctx.font = `${this.fontSize}px arial`
    ctx.fillText(this.text, -canvas.width / 2 - canvas.width * 0.016, 4)
    ctx.closePath()
    return canvas.toDataURL('image/png')
  }

  computerWidth(option) {
    const dom = document.createElement('span')
    dom.style.display = 'inline-block'
    dom.style.fontSize = option.fontSize || '16px'
    dom.innerText = option.text
    document.body.appendChild(dom)
    const width = dom.getBoundingClientRect().width || dom.clientWidth
    document.body.removeChild(dom)
    return width
  }

  // 计算斜边
  computerSide(width) {
    this.height = Math.sin((Math.abs(this.rotate) * Math.PI) / 180) * width
    this.width = Math.sin(((90 - Math.abs(this.rotate)) * Math.PI) / 180) * width
  }

  // 创建水印元素
  createDom() {
    const waterDom = document.createElement('div')
    waterDom.setAttribute(
      'style',
      `position: fixed;width: 100%;height: 100%;z-index: 100000;top: 70px;left:0;pointer-events: none;background-image: url(${
        this.imageUrl
      }), url(${this.imageUrl}); background-position: 80px 137px, 0 0;
       background-repeat: repeat, repeat;
       opacity: .05;
       ${this.style + ';'}`
    )
    waterDom.setAttribute('id', 'waterDom')
    return waterDom
  }

  append() {
    const dom = document.querySelector('#waterDom')
    if (dom) document.body.removeChild(dom)
    this.waterDom = this.createDom()
    document.body.appendChild(this.waterDom)
  }

  // 插入元素
  watcherDelWaterDom() {
    if (window.MutationObserver) {
      this.observer = new MutationObserver(() => {
        this.append()
        this.watch()
      })
      this.bodyObserver = new MutationObserver(() => {
        const dom = document.querySelector('#waterDom')
        if (!dom) return this.append()
        this.watch()
      })
    }
  }

  // 监听
  watch() {
    this.observer.observe(this.waterDom, {
      childList: true, // 观察目标子节点的变化，是否有添加或者删除
      attributes: true, // 观察属性变动
      subtree: true // 观察后代节点，默认为 false
    })
    this.bodyObserver.observe(document.body, {
      childList: true // 观察目标子节点的变化，是否有添加或者删除
    })
  }
}

export default Watermark
